import PropTypes from 'prop-types';

const TermsAndCondition = ({data}) => {
  return (
    <div className={'w-full flex justify-center items-center lg:px-20 p-4'}>
      <div className={'flex flex-col'}>
        <h1 className={'font-serif-custom lg:text-2xl text-xl text-primary-900 mb-4 text-center'}>Terms & Conditions</h1>
        <ul className={'list-disc p-2 text-primary-900'}>
          {data.terms.map((items, index) => (
            <li key={index} className={'mb-4'}>
              <h2 className={'font-semibold font-serif text-primary-900'}>{items.term}</h2>
              <p className={'text-sm'}>{items.description}</p>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

TermsAndCondition.propTypes = {
  data: PropTypes.shape({
    terms: PropTypes.arrayOf(
      PropTypes.shape({
        term: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
      }),
    ).isRequired,
  }).isRequired,
};

export default TermsAndCondition;
